import React, { useState, useEffect } from "react";

export const svg = `<svg width="40" height="40" viewbox="0 0 40 40" viewBox="0 -8 56 80" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.13 64c-2.578 0-4.587-2.21-4.312-4.742l1.95-17.993A1.148 1.148 0 0 0 20.618 40H5.847a2.324 2.324 0 0 1-1.762-.805L2.55 37.412a2.265 2.265 0 0 1-.068-2.878L29.321.222A.58.58 0 0 1 29.778 0h2.046c2.577 0 4.586 2.21 4.311 4.742l-1.95 17.993A1.148 1.148 0 0 0 35.335 24h14.784c.672 0 1.31.289 1.75.791l1.568 1.794c.72.823.753 2.034.079 2.894l-26.884 34.3a.58.58 0 0 1-.457.221h-2.046Z" fill="url(#blitz-logo-a)"></path><path d="m20.812 59.365 1.95-17.993c.14-1.28-.874-2.372-2.143-2.372H5.846c-.39 0-.756-.17-1.004-.457L3.309 36.76a1.265 1.265 0 0 1-.038-1.61L29.98 1h1.843c1.995 0 3.526 1.706 3.317 3.635l-1.95 17.993c-.14 1.28.874 2.372 2.143 2.372H50.12c.385 0 .749.166.997.45l1.568 1.793c.404.462.422 1.137.045 1.62L25.972 63h-1.843c-1.995 0-3.526-1.706-3.317-3.635Z" stroke="url(#blitz-logo-b)" stroke-width="2" fill="transparent"></path><defs><linearGradient id="blitz-logo-a" x1="45.528" y1="40.793" x2="15.769" y2="15.467" gradientUnits="userSpaceOnUse"><stop stop-color="#CE0F50"></stop><stop offset="1" stop-color="#FE112D"></stop></linearGradient><linearGradient id="blitz-logo-b" x1="28" y1="0" x2="28" y2="64" gradientUnits="userSpaceOnUse"><stop stop-color="#FF003D"></stop><stop offset="1" stop-color="#FF003D" stop-opacity="0"></stop></linearGradient></defs></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
